import { render } from "./CardCategoriasComponent.vue?vue&type=template&id=98008984&scoped=true"
import script from "./CardCategoriasComponent.vue?vue&type=script&lang=js"
export * from "./CardCategoriasComponent.vue?vue&type=script&lang=js"

import "./CardCategoriasComponent.vue?vue&type=style&index=0&id=98008984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98008984"]])

export default __exports__